import { previewRenderers } from 'Cube/view/layouts/quote/QuoteEditorPreview/previewRenderers.adapters'
import {
  CubeReducerState,
  ValidationResult
} from 'modules/Cube/domain/cube.domain.types'

const collectAllStrings = (value: unknown): string[] => {
  if (typeof value === 'string') {
    return [value]
  }

  if (Array.isArray(value)) {
    return value.flatMap(collectAllStrings)
  }

  if (value !== null && typeof value === 'object') {
    return Object.values(value).flatMap(collectAllStrings)
  }

  return []
}

export const noInvalidESignatureCharacters = (
  prevState: CubeReducerState
): ValidationResult[] | null => {
  const results: ValidationResult[] = []

  const pdfData = previewRenderers.pdfPreview.in({
    rawData: prevState,
    orderedPhases: prevState.queries.orderedPhases,
    amendment: prevState.queries.amendment
  })
  const allStrings = collectAllStrings(pdfData)

  const contactNames = (prevState.data.quote.contacts ?? [])
    .map(c => c.name)
    .filter(Boolean) as string[]
  const counterSignerNames = (prevState.data.quote.counterSigners ?? [])
    .map(cs => cs.name)
    .filter(Boolean) as string[]

  const allText = [...allStrings, ...contactNames, ...counterSignerNames]

  if (allText.some(str => str.includes('[$'))) {
    results.push({
      message:
        'Quote contains the characters [$ which are incompatible with Dropbox Sign'
    })
  }

  return results.length ? results : null
}
